const players = {
  jplayer: 'jplayer',
  hlsjs: 'hlsjs',
  wmp: 'wmp',
  webmediaplayer: 'webmediaplayer',
};

export default players;
